import { Injectable } from '@angular/core';
import { SmartyStreetsService } from './smarty-streets.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private smartyStreetsService: SmartyStreetsService){
  }

  autocompleteAddress(address: any, requiredState: string, stateRestrciton: boolean){
    //, poBoxRestricted: boolean
      let addressLine1;
      if(address.hasOwnProperty('addressLine1')){
        addressLine1 = address?.addressLine1;
      }
      if(address.hasOwnProperty('address1Txt')){
        addressLine1 = address?.address1Txt;
      }
      if(address.hasOwnProperty('addressLine1Txt')){
        addressLine1 = address?.addressLine1Txt;
      }
      return this.smartyStreetsService.autocompleteAddress(addressLine1, requiredState, stateRestrciton, '');
  }

  autocompleteSelectedAddress(address: string, selectedSuggesion: any){
    return this.smartyStreetsService.autocompleteAddress(address, '', false, selectedSuggesion);
  }

  public setAddressDetails(modelObj:any, suggestion:any){
   
    modelObj.zipCd = suggestion?.option?.value?.zipcode;
    modelObj.cityTxt = suggestion?.option?.value?.city.toUpperCase();
    modelObj.stateCd = suggestion?.option?.value?.state;

    if(modelObj.hasOwnProperty('addressLine1')){
      modelObj.addressLine1 = suggestion?.option?.value?.street_line.toUpperCase();
    }
    if(modelObj.hasOwnProperty('addressLine2')){
      modelObj.addressLine2 = suggestion?.option?.value?.secondary.toUpperCase();
    }
    if(modelObj.hasOwnProperty('addressLine1Txt')){
      modelObj.addressLine1Txt = suggestion?.option?.value?.street_line.toUpperCase();
    }
    if(modelObj.hasOwnProperty('addressLine2Txt')){
      modelObj.addressLine2Txt = suggestion?.option?.value?.secondary.toUpperCase();
    }
    if(modelObj.hasOwnProperty('address2Txt')){
      modelObj.address2Txt = suggestion?.option?.value?.secondary.toUpperCase();
    }
    if(modelObj.hasOwnProperty('address1Txt')){
      modelObj.address1Txt = suggestion?.option?.value?.street_line.toUpperCase();
    }
   
  }

}
